import { Box, Icon, Text } from '@quintoandar-tokko/jopijs';
import FilterBar from '@/components/FilterBar';
import { DASHBOARD_TABS } from '../constants';
import styles from './dashboardFilters.module.scss';
import Trans from '@/components/shared/Trans';
import translations from '@/components/Dashboard/Dashboard.trans.json';
import useHideOnScroll from '@/hooks/useHideOnScroll';
import useDashboardFiltersState from './useDashboardFiltersState';

const TAB_DATA_ATTR = {
  [DASHBOARD_TABS.TODO]: 'pending',
  [DASHBOARD_TABS.OVERVIEW]: 'overview',
  [DASHBOARD_TABS.PERFORMANCE]: 'performance',
};

function DashboardFilters() {
  const { isHidden, show } = useHideOnScroll();
  const {
    edition,
    tabActive,
    canSeeFilters,
    showTeamsfilter,
    filteredSelectedIds,
    shouldHideFilteringBy,
    showSelectionTags,
    showFilterIcon,
  } = useDashboardFiltersState(isHidden);

  if (!canSeeFilters && tabActive !== DASHBOARD_TABS.PERFORMANCE) return null;

  return (
    <Box
      className={styles.dashboardFilters}
      data-testid="dashboard-filters"
      data-tab={TAB_DATA_ATTR[tabActive]}
      data-editing={edition.active}
      data-hidden={shouldHideFilteringBy}
    >
      <FilterBar
        deleteRangeDate={false}
        showAgentsfilter={canSeeFilters}
        showBranchesfilter={canSeeFilters}
        showTeamsfilter={showTeamsfilter}
        showRangeDate={tabActive === DASHBOARD_TABS.PERFORMANCE}
        showSelectionTags={showSelectionTags}
        selectionTagsItems={filteredSelectedIds}
        showClearFilters={false}
      />

      {showFilterIcon && (
        <Box className={styles.filterIconContainer} onClick={show}>
          <Box className={styles.iconWrapper}>
            <Icon icon="icon-filtros" fontSize="16px" />
          </Box>
          <Text variant="body.fontSize14">
            {filteredSelectedIds.length === 1
              ? Trans(translations, 'OneFilterApplied')
              : Trans(
                  translations,
                  'dashboardFiltersApply.filtersApplied',
                  filteredSelectedIds.length
                )}
          </Text>
        </Box>
      )}
    </Box>
  );
}

export default DashboardFilters;
